$(function() {
    /* sticky nav START */  
    $('html, body').scroll(function() {
        var navOffset = $('.l-header').offset().top;
        var wScroll = $(this).scrollTop();

        console.log(wScroll);
        
        if (wScroll > navOffset) {
            $('.l-header').attr("class","l-header fixed");
            $('.btn-aside').toggleClass('on');
        } else {
            $('.l-header').attr("class","l-header");
        }
    });   
    /* sticky nav END */  

    /** gotop START */
    $('.btn-gotop').click(function(){
        $('html, body').animate({scrollTop: 0}, 800);
    });
    /* gotop END */  

    /* Nav START */
    $('.navbar').hover(function(){
        $(this).addClass('on');
        $(".l-header").addClass('on');
    }, function(){
        $(this).removeClass('on');
        $(".l-header").removeClass('on');
        $('.sub-wrap').hide();
    });

    $('.nav-link').hover(function(){
        $('.sub-wrap').hide();
        $(this).next('.sub-wrap').show();

        $('.nav-link').removeClass('on');
        $(this).addClass('on');
        }, function(){
    });
    /* Nav END */  
    
    /* m Nav START */
    $('.nav-link').click(function(e){
        e.preventDefault();

        $(this).toggleClass('active');
		$('.nav-link').removeClass('selected');
		$(this).addClass('selected');
        $(this).next('.sub-list').slideToggle();
    });
    /* m Nav END */
    
    /* Tabs START */
    $('.tabs a').click(function() {
        $('.tabs a').removeClass('on');
        $(this).toggleClass('on');

        $('.tab-cont').hide();
        $($(this).attr('href')).show();
        return false;
    });
    /**  Tabs END */

    /* job duty START */
    $('.accordion dt').click(function() {
        $(this).toggleClass('on');
        $(this).next('dd').toggle();
    });
    /* job duty END */    

    $('.btn-aside').click(function() {
        $(this).toggleClass('on');
        $('.m-header, .modal-backdrop, body').toggleClass('on');
    });

});

//# sourceMappingURL=main.js.map